import React from "react";
import { topSectionData, footerSection, NavSection } from "./HeaderAndFooter";
import { Helmet } from "react-helmet";
import { Fade, Zoom, } from 'react-reveal';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

const contentSection = (
  <>
    <div class='dispfbanner'>
      <div class='bannerarea'>
        <h4 data-aos='zoom-in-down'>Play Pickle-Ball in your Favorite arena</h4>
        <h1 data-aos='fade-up'>
          We Are Redefining Sports. Experience The Difference
        </h1>
        <div class='btarea' data-aos='zoom-in'></div>
      </div>
    </div>
    <div class='aboutarea ' data-aos='zoom-in'>
      <div class='aboutbox '>
        <div class='boxes '>
          <svg>
            <use href='#park'></use>
          </svg>
          <h5> Online Booking available</h5>
        </div>
        <div class='boxes '>
          <svg viewBox='0 0 55.558 47.814'>
            <use href='#stadium'></use>
          </svg>
          <h5> Best in Class Infra</h5>
        </div>
        <div class='boxes '>
          <svg>
            <use href='#football'></use>
          </svg>
          <h5> All equipments complimentary </h5>
        </div>
      </div>
    </div>
  </>
);

const pickleVenueList = [
  {
    companyName: "PlayAll",
    venueName: "PlayAll Noida 105",
    numberOfCourts: 3,
    city: "Noida",
    address: "Fortune World School, B280 b, Block B, Sector 105, Noida | Contact - 01141169966",
    googleMapLink: "https://maps.app.goo.gl/ephtqiRQdqVwajjB6",
    images: [
      "https://d21gjxs9m3o5hx.cloudfront.net/uploadvenueimages/1751094049873-filename0.jpg"
       ]
  },
  {
    companyName: "PlayAll",
    venueName: "PlayAll MGR Mogappair East",
    numberOfCourts: 3,
    city: "Chennai",
    address: "Veeramamunivar St, Block 12, Block 11, J J Nagar, Anna Nagar, Chennai, Tamil Nadu - 600037 | Contact - 044-40114443",
    googleMapLink: "https://maps.app.goo.gl/hWTDbGtjTnEi5YNg6",
    images: [
      "https://d21gjxs9m3o5hx.cloudfront.net/uploadvenueimages/1740379134472-filename0.jpg"
       ]
  },
  {
    companyName: "PlayAll",
    venueName: "PlayAll MPS Noida 11",
    numberOfCourts: 3,
    city: "Noida",
    address: "S1 Modern School, R Block, Sector 11, Noida | Contact - 01141169060",
    googleMapLink: "https://goo.gl/maps/boJhPCxZzf2iZk7s9",
    images: [
      "https://d21gjxs9m3o5hx.cloudfront.net/uploadvenueimages/1750403456058-filename0.jpg",
      "https://d21gjxs9m3o5hx.cloudfront.net/uploadvenueimages/1750403476985-filename0.jpg"
       ]
  },
  {
    companyName: "PlayAll",
    venueName: "PlayAll HICAS Coimbatore",
    numberOfCourts: 3,
    city: "Coimbatore",
    address: " Hindustan College of Arts & Science, Avinashi Rd, behind Nava India, Udayampalayam, Coimbatore, Tamil Nadu 641028 | Contact - 044-40114355",
    googleMapLink: "https://maps.app.goo.gl/W66hgWjS37q92m9p8",
    images: [
      "https://d21gjxs9m3o5hx.cloudfront.net/uploadvenueimages/1740379134472-filename0.jpg"
       ]
  },
  {
    companyName: "PlayAll",
    venueName: "PlayAll Faridabad 82",
    numberOfCourts: 2,
    city: "Faridabad",
    address: "St. Mary's Convent Senior Secondary School, Bhatola,Sector-82, Faridabad | Contact - 011-407-87458",
    googleMapLink: "https://maps.app.goo.gl/UMWHVWVVmcyE4VA47",
    images: [
      "https://d21gjxs9m3o5hx.cloudfront.net/uploadvenueimages/1744347205815-filename0.jpg"
       ]
  },
  {
    companyName: "PlayAll",
    venueName: "PlayAll MCL Hari Nagar",
    numberOfCourts: 3,
    city: "Delhi",
    address: "MCL Saraswati Bal Mandir, L-Block, Hari Nagar, New Delhi, Delhi, 110064 | Contact - 011-411-71633",
    googleMapLink: "https://maps.app.goo.gl/bTNYvDwemSUN6xDg9",
    images: [
      "https://d21gjxs9m3o5hx.cloudfront.net/uploadvenueimages/1743157513444-filename1.jpg"
       ]
  },
  {
    companyName: "PlayAll",
    venueName: "PlayAll SWS Greater Noida",
    numberOfCourts: 3,
    city: "Greater Noida",
    address: "Sanfort World School, Block A, Ansal Golf Links 1, Greater Noida, Uttar Pradesh 201310 | Contact - 	011-407-87380",
    googleMapLink: "https://maps.app.goo.gl/AnkKhzgj1YSVAse5A",
    images: [
      "https://d21gjxs9m3o5hx.cloudfront.net/allvenues/sanfort+world+school+%2Comega+1%2Cgreater+noida/stanford3.jpg",
      "https://d21gjxs9m3o5hx.cloudfront.net/allvenues/sanfort+world+school+%2Comega+1%2Cgreater+noida/stanford4.jpg"
    ]
  },
  {
    companyName: "PlayAll",
    venueName: "PlayAll Noida 73",
    numberOfCourts: 4,
    city: "Noida",
    address: "Near Noida Pet Clinic, Sector 73, Noida, Uttar Pradesh 201301 | Contact - 01140849901",
    googleMapLink: "https://goo.gl/maps/MHyikEmmcw22",
    images: [
      "images/gallery/noida_73_pickle_ball.png",
    ]
  },
  {
    companyName: "PlayAll",
    venueName: "PlayAll Orbit Mall",
    numberOfCourts: 3,
    city: "Jaipur",
    address: "Civil Lines Metro Station, Orbit Mall, Ajmer Rd, Madrampur, Civil Lines, Jaipur, Rajasthan 302006 | Contact - 	011-411-86654",
    googleMapLink: "https://goo.gl/maps/4VAo7j8ZzX9rBojQ9",
    images: [
      "https://d21gjxs9m3o5hx.cloudfront.net/uploadvenueimages/1744347157541-filename0.jpg",
    ]
  },
  {
    companyName: "PlayAll",
    venueName: "PlayAll Faridabad 86",
    numberOfCourts: 2,
    city: "Faridabad",
    address: "Near Sai Mandir, Sector 86, Faridabad, Haryana 121002| Contact - 01141187780",
    googleMapLink: "https://maps.app.goo.gl/NXWdbBZ4TipBSeUh9",
    images: [
      "images/gallery/faridabad_86_pickle_ball.png",
    ]
  },
  {
    companyName: "PlayAll",
    venueName: "PlayAll NGF Alaknanda",
    numberOfCourts: 3,
    city: "New Delhi",
    address: "New Green Field School, Alaknanda, New Delhi, Delhi| Contact - 011-411-87496",
    googleMapLink: "'https://maps.app.goo.gl/a9iKRNwGpwH3xgreA",
    images: [
      "images/gallery/NGF_box_cricket_2.png",
      "images/gallery/NGF_box_cricket_1.png",
      "images/gallery/NGF_box_cricket_3.png",
    ]
  }
]
const mainSection = (
  <>
    <main>
      {pickleVenueList.map((item, index) => {
        return (
          <section class='partnersec ' key={`effejkbjdfb${index}`}>
            <div class='container'>
              <div class='innerbx pb-5'>
                {index % 2 === 0 ?
                  <div class='contentarea '>
                    <Zoom>  <h4 >{item.companyName}</h4>
                      <h2 >{item.venueName}</h2>
                      <p>With {item.numberOfCourts} Best-in-Class <b>Pickle Ball Courts</b>, PlayAll is one of the best <b>Pickle Ball Arena</b> in {item.city}. With Amenities like Ample Parking, Shower, and Sports Shop, we ensure that your Pickle Ball experience is hassel free and awesome. </p>

                    </Zoom>

                    <span class='address'>
                      Address - {item.address}
                    </span>
                    <div class='btarea mb-3'>


                      <a href={item.googleMapLink} class='btwhite1'
                        target="_blank"
                        rel="noreferrer"
                      >

                        <svg width='34' height='41'>
                          <use href='#googleMap'></use>
                        </svg>
                        <Zoom >Directions</Zoom>
                      </a>
                    </div>


                    <div class='sportsavailble'>
                      <Zoom>Book via</Zoom>
                      <div class='divider'></div>
                      <a
                        href='https://play.google.com/store/apps/details?id=com.playallrn'
                        class='btorng'
                        style={{ background: "#000000" }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {" "}
                        <img alt='' src='images/playStore.png' style={{ height: "120px" }} />
                      </a>


                      <div class='divider'></div>
                      <a
                        class='btorng justify-content-center'
                        href='https://apps.apple.com/us/app/play-all/id6480510323'
                        style={{ background: "#000000" }}
                        rel="noreferrer"
                        target="_blank"
                      >
                        <img src='images/appStore.png' alt='' style={{ height: "120px" }} />
                      </a>
                    </div>


                  </div>
                  :
                  <div class=' rightbx startplayarea1 d-flex justify-content-center'>
                    <div class='startplaybox'>
                      <Fade >
                        <Carousel showThumbs={false} showIndicators={false} showStatus={false} autoPlay={true} infiniteLoop={true} interval={1400} swipeable={true} emulateTouch={true}>
                          {item.images.map((insideItem, index) => {
                            return (
                              <img src={insideItem} alt='pickleball in jaipur' key={`ewfhewhklkwebkj${index}`} />
                            )
                          })}

                        </Carousel></Fade>
                    </div>
                  </div>
                }
                {index % 2 === 0 ?
                  <div class=' rightbx startplayarea1 d-flex justify-content-center'>
                    <div class='startplaybox'>
                      <Fade >
                        <Carousel showThumbs={false} showIndicators={false} showStatus={false} autoPlay={true} infiniteLoop={true} interval={1400} swipeable={true} emulateTouch={true}>
                          {item.images.map((insideItem, index) => {
                            return (
                              <img src={insideItem} alt='pickleball in jaipur' key={`ewfhewhklkwebkj${index}`} />
                            )
                          })}

                        </Carousel></Fade>
                    </div>
                  </div>
                  :
                  <div class='contentarea '>
                    <Zoom>  <h4 >{item.companyName}</h4>
                      <h2 >{item.venueName}</h2>
                      <p>With {item.numberOfCourts} Best-in-Class <b>Pickle Ball Courts</b>, PlayAll is one of the best <b>Pickle Ball Arena</b> in {item.city}. With Amenities like Ample Parking, Shower, and Sports Shop, we ensure that your Pickle Ball experience is hassel free and awesome. </p>

                    </Zoom>

                    <span class='address'>
                      Address - {item.address}
                    </span>
                    <div class='btarea mb-3'>


                      <a href={item.googleMapLink} class='btwhite1'
                        target="_blank"
                        rel="noreferrer"
                      >

                        <svg width='34' height='41'>
                          <use href='#googleMap'></use>
                        </svg>
                        <Zoom >Directions</Zoom>
                      </a>
                    </div>


                    <div class='sportsavailble'>
                      <Zoom>Book via</Zoom>
                      <div class='divider'></div>
                      <a
                        href='https://play.google.com/store/apps/details?id=com.playallrn'
                        class='btorng'
                        style={{ background: "#000000" }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {" "}
                        <img alt='' src='images/playStore.png' style={{ height: "120px" }} />
                      </a>


                      <div class='divider'></div>
                      <a
                        class='btorng justify-content-center'
                        href='https://apps.apple.com/us/app/play-all/id6480510323'
                        style={{ background: "#000000" }}
                        rel="noreferrer"
                        target="_blank"
                      >
                        <img src='images/appStore.png' alt='' style={{ height: "120px" }} />
                      </a>
                    </div>


                  </div>

                }

              </div>
            </div>
          </section>
        )
      })}
    </main>
   
  </>
);

const PickleBall = () => {
  return (
    <>

      <Helmet>
        <title>Pickle Ball Courts</title>
        <meta name="description" content="Play all offers best Pickle Ball courts in Faridabad" />
      </Helmet>
      <div style={{ overflowY: "scroll", height: "calc(100vh)" }}>
        {topSectionData}
        <div class='headbanner pickleBallBg' data-aos='fade'>
          <div class='container '>
            <NavSection current={"pickleBall"} />
            {contentSection}
          </div>
        </div>
        {mainSection}
        {footerSection}
      </div>
    </>
  );
};

export default PickleBall;
